import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { helpers } from 'redux-firebasev3';

import ErrorPageRequiresAuthentication
from '../components/ErrorPageRequiresAuthentication';
import teamIdForUid from '../utils/teamIdForUid';

const { pathToJS } = helpers;

export default function teamIdFromAuth({ hideOnUnauthenticated = false } = {}) {
  return BaseComponent => {
    @connect(
      ({ firebase }) => ({
        auth: pathToJS(firebase, 'auth'),
      })
    )
    class TeamIdFromAuth extends Component {
      static displayName =
        `teamIdFromAuth(${BaseComponent.displayName || BaseComponent.name})`;

      static propTypes = {
        auth: PropTypes.object,
      };

      render() {
        const { auth } = this.props;

        if (!auth) {
          if (hideOnUnauthenticated) {
            return <div />;
          }
          return <ErrorPageRequiresAuthentication />;
        }

        return (
          <BaseComponent {...this.props} teamId={teamIdForUid(auth.uid)} />
        );
      }
    }
    return TeamIdFromAuth;
  };
}



/** WEBPACK FOOTER **
 ** ./src/enhancers/teamIdFromAuth.jsx
 **/